module.exports = __webpack_public_path__ + "img/logo_koperasi.ca080299.png";